<div bsModal #quickSearchResultsModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
     [attr.aria-label]="'QUICK_SEARCH_DIALOG' | translate:locale.language" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="close.emit()" [attr.aria-label]="'CLOSE' | translate:locale.language">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{'QUICK_SEARCH_DIALOG_TITLE' | translate:locale.language}}</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="count === 0">
          <h5>{{ 'QUICK_SEARCH_DEVICE_NOT_FOUND' | translate:locale.language }} : {{pattern}}</h5>
        </div>
        <div class="table-responsive" *ngIf="count > 0">
          <storever-datatable [striped]="true"
                              [hover]="true"
                              [data]="results"
                              [count]="count"
                              [currentPage]="currentPage"
                              [itemsPerPage]="itemsPerPage"
                              [orderBy]="orderBy"
                              (pageSizeChange)="pageSizeChanged.emit($event)"
                              (pageChange)="pageChanged.emit($event)"
                              (orderByChange)="orderByChanged.emit($event)">
            <storever-datatable-column [name]="''"
                                       [prop]="'deviceID'">
              <ng-template let-row="row" storeverDatatableColumnCell>
                <div *ngIf="row.clientName === 'Storever'">{{ 'PLAYER_IN_STOCK' | translate:locale.language }}</div>
                <button *ngIf="row.clientName !== 'Storever'" type="button" class="btn brand" (click)="gotoPlayer.emit(row)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                  {{ 'GOTO_PLAYER' | translate:locale.language }}
                </button>
              </ng-template>
            </storever-datatable-column>
            <storever-datatable-column [name]="'PLAYER_ID' | translate:locale.language"
                                       [prop]="'name'"
                                       [sortable]="true"></storever-datatable-column>
            <storever-datatable-column [name]="'PLAYER_SITE' | translate:locale.language"
                                       [prop]="'subscriptionName'"
                                       [sortable]="true"></storever-datatable-column>
            <storever-datatable-column [name]="'PLAYER_CLIENT' | translate:locale.language"
                                       [prop]="'clientName'"
                                       [sortable]="true"></storever-datatable-column>
          </storever-datatable>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="close.emit()">{{'CANCEL' | translate:locale.language}}</button>
      </div>
    </div>
  </div>
</div>
